import { PlusOutlined } from "@ant-design/icons";
import useGetDeliverableConfigurators from "@entities/deliverableConfigurator/lib/hooks/useGetDeliverableConfigurators";
import DeliverableForm from "@features/deliverableConfigurator/ui/DeliverableForm";
import FormatCards from "@features/deliverableConfigurator/ui/FormatCards";
import MediaRightsConfigurator from "@features/mediaRightsConfigurator";
import { ToastService } from "@shared/lib/services";
import { IDeliverableConfigurator } from "@shared/lib/types";
import { Button } from "@shared/ui/Button";
import { Col, Input, Modal, Row, Space, Spin, Tabs } from "antd";
import { useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";

const { Search } = Input;

export default function DeliverableConfigurator() {
  const [openEditModal, setOpenEditModal] = useState<{
    deliverable: IDeliverableConfigurator | null;
    open: boolean;
  }>({
    deliverable: null,
    open: false,
  });
  const [openMediaRightsModal, setOpenMediaRightsModal] = useState<{
    open: boolean;
  }>({
    open: false,
  });

  const {
    deliverableConfiguratorsData,
    isDeliverableConfiguratorsFetching,
    deliverableConfiguratorsError,
  } = useGetDeliverableConfigurators();

  useEffect(() => {
    if (deliverableConfiguratorsError) {
      ToastService.error(deliverableConfiguratorsError?.message);
    }
  }, [deliverableConfiguratorsError]);

  const tabItems = useMemo(() => {
    return deliverableConfiguratorsData?.data?.data?.map((val) => ({
      key: `${val.platform}`,
      label: <Space>{val.platform} </Space>,
      children: (
        <FormatCards formats={val.deliverables} deliverableId={val._id ?? ""} />
      ),
    }));
  }, [deliverableConfiguratorsData]);
  return (
    <Spin
      spinning={isDeliverableConfiguratorsFetching}
      style={{ paddingBottom: 20 }}
    >
      <h1 className={styles.title}>Deliverable Configurator</h1>
      <Row justify={"space-between"}>
        {/* <Search
            placeholder="Search by brand name or company name"
            onSearch={(val) => handleSearchChange(val)}
            value={searchQuery}
            onChange={(e) => handleSearchChange(e.target.value)}
            allowClear
            style={{ width: 350 }}
          /> */}
        <Col></Col>
      </Row>
      <Tabs
        items={tabItems}
        tabBarExtraContent={
          <Space>
            <Button
              variant="outlined"
              onClick={() => setOpenMediaRightsModal({ open: true })}
            >
              Configure Media Rights
            </Button>
            <Button
              icon={<PlusOutlined />}
              variant="outlined"
              onClick={() =>
                setOpenEditModal({ open: true, deliverable: null })
              }
            >
              Add Deliverable
            </Button>
          </Space>
        }
      />
      <Modal
        open={openEditModal.open}
        title="Deliverable Configurator"
        footer={null}
        destroyOnClose
        onCancel={() => setOpenEditModal((prev) => ({ ...prev, open: false }))}
      >
        <DeliverableForm
          // initialData={openEditModal.deliverable}
          onClose={() => setOpenEditModal({ open: false, deliverable: null })}
        />
      </Modal>
      <Modal
        open={openMediaRightsModal.open}
        title="Media Rights Configurator"
        footer={null}
        destroyOnClose
        onCancel={() => setOpenMediaRightsModal({ open: false })}
      >
        <MediaRightsConfigurator />
      </Modal>
    </Spin>
  );
}
